export const cashflowCharts = {
  HEB: {
    CashflowSettings: {
      header: "הגדרות תזרים",
      dateSelectionText: "לאיזה חודש לשייך תנועות אשראי?",
      transactionDate: "חודש ביצוע העסקה",
      billingDate: "חודש החיוב בבנק",
      billingDateHelp:
        "כל הוצאה שיש לכם תראו אותה לפי החודש שבה ירדה לכם ההוצאה בבנק.",
      transactionDateHelp:
        "כל הוצאה שיש לכם תראו אותה לפי התאריך בפועל שבו קניתם מוצר או שירות גם אם באשראי זה ירד לכם רק בחודש לאחר מכן.",
    },
    TransactionRulesForm: {
      ThisTransaction: "חוק על תנועה זו",
      RuleCreation: "יצירת חוק קבוע",
      AdvancedRule: "חוק מתקדם",
      infoBanner: "תנועות עבר ותנועות עתידיות יסווגו אוטומטית לפי החוק",
      ifInField: "אם בשדה",
      addAmountCondition: "הוספת תנאי לפי סכום",
      thenChooseAction: "אז- בחירת פעולה:",
      chooseSubcategory: "בחירת תת קטגוריה:",
      chooseCategory: "בחירת קטגוריה:",
      addComment: "הוספת הערה",
      hideTransaction: "הסתרת תנועה",
      markAsSavings: "הגדרה כחיסכון",
      categoryLockWarning:
        "שינוי הקטגוריה הראשית יגרום לשיוך מחדש של כל התנועות בתת-קטגוריה זו",
      unlockCategory: "שנה קטגוריה ראשית",
      unlockConfirmTitle: "שינוי קטגוריה ראשית",
      unlockConfirmMessage: (sub: string) =>
        `שינוי הקטגוריה הראשית ישפיע על כל התנועות שמשויכות לתת-הקטגוריה "${sub}". האם להמשיך?`,
      unlockConfirm: "המשך",
      unlockCancel: "ביטול",
    },
    ManageRules: {
      Sum: "סכום",
      TransactionName: "חוק",
      MoreInfo: "מידע נוסף",
      Action: "פעולה",
      Category: "קטגוריה",
      Header: "ניהול חוקים",
      description: "צפו, ערכו ומחקו חוקים שמסווגים תנועות באופן אוטומטי",
      CategoryRules: "חוקי קטגוריות",
      IgnoreRules: "חוקי התעלמות",
      TagRules: "חוקי תגיות",
      InvestmentRules: "חוקי השקעה",
      MatchingTransactions: "תנועות תואמות",
      editRule: "עריכת חוק",
      deleteRule: "מחיקת חוק",
      noRules: "אין חוקים להצגה",
      noRulesDescription: "חוקים שתיצרו מהתזרים יופיעו כאן",
      search: "חיפוש חוקים",
      sort: "מיון",
    },
    InsightStrings: {
      cardFees: "דמי כרטיס",
      reserverDutyString: "מופ”ת מילואים",
    },
    MultiSelect: {
      selectSomeItems: "בחר חשבונות וכרטיסים",
      allItemsAreSelected: "כל החשבונות והכרטיסים נבחרו",
      selectAll: "בחר הכל",
      search: "חיפוש",
      noOptions: "אין כרטיסים או חשבונות",
    },
    Months: {
      January: "ינואר",
      February: "פברואר",
      March: "מרץ",
      April: "אפריל",
      May: "מאי",
      June: "יוני",
      July: "יולי",
      August: "אוגוסט",
      September: "ספטמבר",
      October: "אוקטובר",
      November: "נובמבר",
      December: "דצמבר",
      All: "כל התקופה",
    },
    CategoryTypes: {
      Main: "מקובץ",
      Sub: "מפורט",
    },
    Categories: {
      All: "הכל",
      Uncategorized: "אחר",
      BusinessExpenses: "הוצאות עסקיות",
      ChecksGeneral: "צ'קים כלליים",
      CreditCardExpenses: "כרטיס אשראי",
      InterestRates: "ריבית",
      CashWithdrawls: "משיכת מזומן",
      FinanceOther: "פיננסים",
      Healthcare: "בריאות",
      InsuranceAndFees: "ביטוח ודמי שירות",
      Saving: "חסכון",
      HomeImprovementsOther: "שדרוגים בבית",
      Home: "בית",
      Rent: "שכירות",
      Garden: "גינה",
      Other: "אחר",
      ReimbursementsOther: "החזרים ",
      Services: "שירותים",
      Fees: "דמי ניהול",
      Loans: "הלוואות",
      BenefitsOthers: "הטבות",
      CapitalMarket: "שוק ההון",
      BooksAndGames: "ספרים ומשחקים",
      Groceries: "מצרכים",
      ShoppingOther: "קניות",
      SportsAndFitness: "ספורט וכושר",
      Restaurant: "מסעדה",
      ClothesAndAccessories: "ביגוד ואביזרים",
      CoffeeAndSnacks: "קפה ונשנושים",
      Electronics: "מוצרי חשמל",
      Pharmacy: "בית מרקחת",
      CarAndFuel: "רכב ודלק",
      Communications: "תקשורת",
      TransportOther: "תחבורה",
      Education: "חינוך",
      HobbyAndSportsEquipment: "תחביבים וציוד ספורט",
      GovernmentServices: "שירותים ממשלתיים",
      AlcoholAndTobacco: "אלכוהול וטבק",
      CultureAndEvents: "תרבות ואירועים",
      Vacation: "חופשה",
      Charity: "צדקה",
      PublicTransport: "תחבורה ציבורית",
      Bars: "ברים",
      Gifts: "מתנות",
      RenovationAndRepairs: "שיפוצים ותיקונים",
      Flights: "טיסות",
      Beauty: "קוסמטיקה",
      Taxi: "מונית",
      LeisureOther: "פנאי",
      FoodAndDrinksOther: "אוכל ושתיה",
      Finance: "פיננסים",
      FoodAndDrinks: "אוכל ושתיה",
      Leisure: "פנאי",
      Shopping: "קניות",
      Transport: "תחבורה",
      HouseholdAndServices: "בית ושירותים",
      HealthAndBeauty: "בריאות ויופי",
      HealthAndBeautyOther: "בריאות ויופי",
      HomeImprovements: "שדרוגים בבית",
      Reimbursements: "החזרים",
      Benefits: "הטבות",
      Salary: "משכורת",
      Utilities: "שירותים",
      Mortgage: "משכנתא",
      FornitureAndInterior: "רהיטים ועיצוב פנים",
      Hobbies: "תחביבים",
      Pets: "חיות מחמד",
      Kids: "ילדים",
      BusinessVendor: "ספק עסקי",
      Unknown: "אחר",
      EyeCare: "בריאות העין",
      SalaryOther: "משכורת",
      Investments: "השקעה/חסכון",
      InvestmentsOrSavins: "השקעות וחסכון",
      DirectDebit: "דביט דיירקט",
      BankTransfer: "העברה בנקאית",
      CreditCardChecking: "כרטיס אשראי",
      FundsNotCover: "אחר",
      IncomesExpenses: "הכנסות/הוצאות",
      NationalInsurance: "ביטוח לאומי",
      NotReserveDuty: "אחר",
      VAT: "מע״מ",
      // Additional specific codes
      Return: "החזר",
      OnlyReturn: "החזר בלבד",
      Refund: "זיכוי",
      Cancelled: "בוטלה",
      ChqReturn: "החזרת צ'ק",
      HokReturn: "החזרת הוראת קבע",
      NegativeBehavior: "התנהלות שלילית",
      Restricted: "חשבון מוגבל",
      Assets: "נכסים",
      LoanTransaction: "פעולת הלוואה",
      Loan: "הלוואה",
      LoanOverdue: "הלוואה בפיגור",
      OverdueSettlement: "סילוק פיגור",
      MinistryOfConstrection: "משרד הבינוי",
      GovExpenses: "הוצאות ממשלתיות",
      Deposit: "הפקדה",
      Transfer: "העברה",
      Insurance: "ביטוח",
      Trading: "מסחר",
      Pension: "פנסיה",
      RecentPension: "עדכון פנסיה",
      Commission: "עמלה",
      ChqCommission: "עמלת צ'ק",
      HokCommission: "עמלת הוראת קבע",
      HokAkamCommission: "עמלת הוראת קבע",
      OverdueRelatedCommission: "עמלת פיגור",
      CashIncome: "הכנסה במזומן",
      ForeignExchange: 'המרת מט"ח',
      Securities: 'ני"ע',
      ChqIncome: "הכנסת צ'ק",
      HealthFund: "קופת חולים",
      Bills: "חשבונות",
      InterestRate: "ריבית",
      ReserveDuty: "מילואים",
      RegisteredMail: "דואר רשום",
      AlertNotice: "הודעת התראה",
      Techni: "פעולה טכנית",
      NotClassified: "לא מסווג",
      NonRevenue: "אחר",
      Alimony: "דמי מזונות",
    },
    Summary: "סיכום תקופתי",
    Cashflow: "תזרים",
    Income: "הכנסות",
    Expenses: "הוצאות",
    SavingsAsPartOfIncome: "חסכון כאחוז מההכנסה",
    Investments: "השקעה/חסכון",
    ExpensesByCategory: "התפלגות הוצאות",
    IncomeByCategory: "התפלגות הכנסות",
    categoryChartEmptyState: "אין תנועות להצגה בתקופה זו",
    IncomeList: "הכנסות",
    ExpensesList: "הוצאות",
    ConnectAccounts: "חיבור חשבונות וכרטיסים",
    Bank: "בנקים",
    Card: "אשראי",
    Cash: "מזומן",
    Manual: "ידני",
    ManualCredit: "אשראי ידני",
    ManualBank: "בנקים ידני",
    BankAndCard: "בנקים ואשראי",
    Sum: "סכום",
    AdditionalData: "מידע נוסף",
    transactionRuleHeader: "התאימו אישית את התזרים",
    ifAppearsInTransaction: "אם בתנועת החשבון בשדה",
    ifAppearsInTransactionShort: " אם בשם התנועה ",
    theValue: "מופיע הערך:",
    valueEquals: "שווה ל:",
    so: "אז",
    date: "תאריך",
    sum: "סכום",
    sort: "מיין לפי",
    category: "קטגוריה",
    filter: "סינון",
    searchTransactions: "חיפוש",
    searchTransactionsPlaceholder: "שם, תיאור או בית עסק",
    clearFilters: "נקה סינון",
    noFilterResults: "אין תנועות התואמות לסינון",
    hideFromCashflow: "הסתר מהתזרים",
    moveToOtherCategory: "תשייך לקטגוריה",
    markAsInvestment: "סמן כהשקעה/חסכון",
    extraInfo: "מידע נוסף",
    transactionName: "שם התנועה ",
    equals: "שווה",
    contains: "מכיל",
    removeRule: "הסר כלל",
    cancel: "ביטול",
    andTheValueIs: "והסכום הוא",
    anySum: "כל סכום",
    typeForAddingNewCategory: "הקלד כדי להוסיף קטגוריה חדשה",
    addNewCategory: "הוסף קטגוריה חדשה",
    addConnection: "+ הוספה",
    id: "מזהה תנועה",
    configureCycle: "ניהול מחזור חודשי",
    configureCycleDesc: "באיזה יום בחודש להתחיל את המחזור החודשי?",
    customDates: "תאריכים מותאמים אישית",
    SummaryByMonth: "תזרים לפי חודש",
    noDataCurrentlyBEcauseYouAreNotConnected:
      "אין נתונים כרגע מאחר ואינך מחובר לחשבונות או כרטיסים",
    fetchErrorMessage:
      "לא הצלחנו לטעון את נתוני התזרים. בדקו את החיבור לאינטרנט ונסו שוב.",
    loadingCashflow: "טוען את התזרים…",
    retryButton: "נסו שוב",
    ToCashflow: "לתזרים",
    IfYouAreConnectedAndNoDataDisplayedGoToCashfow:
      "אם כבר חיברת חשבונות או כרטיסים ועדיין לא מוצג שום דבר נסו לעבור ",
    ToShowMoreAccurateData: "לדיוק הנתונים עברו ",
    Help: "עזרה",
    manageTags: "ניהול תגיות",
    manageCategories: "ניהול קטגוריות",
    manageLaws: "ניהול חוקים",
    senttings: "הגדרות",
    exportToFile: "ייצוא לקובץ",
    refresh: "רענון",
    clickOnVideoToGetExplanation:
      "לחצו על הסרטון לקבלת הסבר על העבודה עם התזרים",
    manageCashflow: "ניהול",
    tabCashflow: "תזרים",
    tabBudget: "תקציב",
    moveToBudget: "מעבר לתקציב",
    monthlyChartPremiumLock: "תזרים לפי חודש זמין רק למנויי פרימיום",
    bankConnectedCardWarning:
      "המידע לגבי תנועות אשראי המגיע מהחיבור לבנק עשוי להיות לא מדויק, להכיל כפילויות וחוסרים. מומלץ לחבר את האשראי ישירות דרך חברת האשראי",
    andAmountEquals: " וסכום=",
    duplicateTransactionShort: "כפילות",
    duplicateNotIncludedInCashflow: "לא נספר בתזרים",
    duplicateMarkedRealLine: "מסומן כעסקה אמיתית · נספר בתזרים",
    duplicateConfirmCheckHint: "לחצו על הסימון ✓ כדי לכלול את התנועה בתזרים",
    duplicatePressCheckToUndoReal:
      "לחצו שוב על הסימון ✓ כדי לבטל — התנועה תיחשב ככפילות שלא נספרת",
    duplicateIncludeInFlowButton: "כלול בתזרים",
    duplicateUndoIncludeButton: "בטל כלילה בתזרים",
    hiddenTransactionLabel: "טרנזקציה מוסתרת",
    ignoredByRuleShort: "מוסתר",
    ignoredByRuleNotIncludedInCashflow: "לא נספר בתזרים",
    ignoredByRuleHint:
      "תנועה זו הוסתרה באמצעות כלל שהגדרתם. לחצו על האייקון 👁 כדי לבטל",
    connectedCardShort: "כרטיס מקושר",
    connectedCardNotIncludedInCashflow: "לא נספר בתזרים",
    connectedCardHint: "תנועה זו מוסתרת כי העסקאות שתחתיה כבר מוצגות בהוצאות",
    transactionActions: "פעולות",
    actionIgnore: "הסתר מהתזרים",
    actionUnignore: "הצג בתזרים",
    actionCreateRule: "יצירת חוק",
    actionEditRule: "עריכת חוק",
    actionChangeCategory: "שינוי קטגוריה",
    actionEditTransaction: "עריכת תנועה",
    actionMarkInvestment: "סמן כהשקעה/חסכון",
    actionUnmarkInvestment: "בטל סימון השקעה/חסכון",
    moreInfoAndComments: "מידע נוסף והערות",
    commentsLabel: "הערות",
    commentsPlaceholder: "הוסיפו הערה...",
    commentEditPlaceholder: "ערכו הערה...",
    commentSave: "שמור",
    executionDate: "תאריך ביצוע",
    transactionDateLabel: "תאריך עסקה",
    billingValueDateLabel: "תאריך חיוב",
    merchantNameLabel: "בית עסק",
    merchantDetailsLabel: "פרטים",
    merchantLocationLabel: "מיקום",
    beneficiaryName: "שם המוטב",
    businessAddress: "כתובת בית העסק",
    accountInfo: "פרטי חשבון",
  },
  ENG: {
    CashflowSettings: {
      header: "Cash flow settings",
      dateSelectionText:
        "Which month should credit transactions be assigned to?",
      transactionDate: "Transaction month",
      billingDate: "Bank billing month",
      billingDateHelp:
        "Each expense will be shown according to the month it was charged to your bank.",
      transactionDateHelp:
        "Each expense will be shown according to the actual date of purchase, even if the credit charge occurs the following month.",
    },
    TransactionRulesForm: {
      ThisTransaction: "Rule on this transaction",
      RuleCreation: "Create permanent rule",
      AdvancedRule: "Advanced rule",
      infoBanner:
        "Past and future transactions will be automatically classified by this rule",
      ifInField: "If in field",
      addAmountCondition: "Add condition by amount",
      thenChooseAction: "Then - choose action:",
      chooseSubcategory: "Choose subcategory:",
      chooseCategory: "Choose category:",
      addComment: "Add comment",
      hideTransaction: "Hide transaction",
      markAsSavings: "Mark as savings",
      categoryLockWarning:
        "Changing the parent category will reassign all transactions in this subcategory",
      unlockCategory: "Change parent category",
      unlockConfirmTitle: "Change parent category",
      unlockConfirmMessage: (sub: string) =>
        `Changing the parent category will reassign all transactions currently under the subcategory "${sub}". Do you want to proceed?`,
      unlockConfirm: "Proceed",
      unlockCancel: "Cancel",
    },
    ManageRules: {
      Sum: "Amount",
      TransactionName: "Rule",
      MoreInfo: "More info",
      Action: "Action",
      Category: "Category",
      Header: "Manage rules",
      description:
        "View, edit, and delete rules that classify transactions automatically",
      CategoryRules: "Category rules",
      IgnoreRules: "Ignore rules",
      TagRules: "Tag rules",
      InvestmentRules: "Investment rules",
      MatchingTransactions: "Matching transactions",
      editRule: "Edit rule",
      deleteRule: "Delete rule",
      noRules: "No rules to show",
      noRulesDescription: "Rules created from cashflow will appear here",
      search: "Search rules",
      sort: "Sort",
    },
    InsightStrings: {
      cardFees: "Card fees",
      reserverDutyString: "Reserve duty",
    },
    MultiSelect: {
      selectSomeItems: "Select accounts and cards",
      allItemsAreSelected: "All accounts and cards selected",
      selectAll: "Select all",
      search: "Search",
      noOptions: "No cards or accounts",
    },
    Months: {
      January: "Jan",
      February: "Feb",
      March: "Mar",
      April: "Apr",
      May: "May",
      June: "Jun",
      July: "Jul",
      August: "Aug",
      September: "Sep",
      October: "Oct",
      November: "Nov",
      December: "Dec",
      All: "All period",
    },
    CategoryTypes: {
      Main: "Grouped",
      Sub: "Detailed",
    },
    Categories: {
      All: "All",
      Uncategorized: "Other",
      BusinessExpenses: "Business expenses",
      ChecksGeneral: "General checks",
      CreditCardExpenses: "Credit card",
      InterestRates: "Interest",
      CashWithdrawls: "Cash withdrawal",
      FinanceOther: "Finance",
      Healthcare: "Healthcare",
      InsuranceAndFees: "Insurance & fees",
      Saving: "Savings",
      HomeImprovementsOther: "Home improvements",
      Home: "Home",
      Rent: "Rent",
      Garden: "Garden",
      Other: "Other",
      ReimbursementsOther: "Reimbursements",
      Services: "Services",
      Fees: "Management fees",
      Loans: "Loans",
      BenefitsOthers: "Benefits",
      CapitalMarket: "Capital markets",
      BooksAndGames: "Books & games",
      Groceries: "Groceries",
      ShoppingOther: "Shopping",
      SportsAndFitness: "Sports & fitness",
      Restaurant: "Restaurant",
      ClothesAndAccessories: "Clothing & accessories",
      CoffeeAndSnacks: "Coffee & snacks",
      Electronics: "Electronics",
      Pharmacy: "Pharmacy",
      CarAndFuel: "Car & fuel",
      Communications: "Communications",
      TransportOther: "Transport",
      Education: "Education",
      HobbyAndSportsEquipment: "Hobbies & sports equipment",
      GovernmentServices: "Government services",
      AlcoholAndTobacco: "Alcohol & tobacco",
      CultureAndEvents: "Culture & events",
      Vacation: "Vacation",
      Charity: "Charity",
      PublicTransport: "Public transport",
      Bars: "Bars",
      Gifts: "Gifts",
      RenovationAndRepairs: "Renovation & repairs",
      Flights: "Flights",
      Beauty: "Beauty",
      Taxi: "Taxi",
      LeisureOther: "Leisure",
      FoodAndDrinksOther: "Food & drinks",
      Finance: "Finance",
      FoodAndDrinks: "Food & drinks",
      Leisure: "Leisure",
      Shopping: "Shopping",
      Transport: "Transport",
      HouseholdAndServices: "Household & services",
      HealthAndBeauty: "Health & beauty",
      HealthAndBeautyOther: "Health & beauty",
      HomeImprovements: "Home improvements",
      Reimbursements: "Reimbursements",
      Benefits: "Benefits",
      Salary: "Salary",
      Utilities: "Utilities",
      Mortgage: "Mortgage",
      FornitureAndInterior: "Furniture & interior",
      Hobbies: "Hobbies",
      Pets: "Pets",
      Kids: "Kids",
      BusinessVendor: "Business vendor",
      Unknown: "Other",
      EyeCare: "Eye care",
      SalaryOther: "Salary",
      Investments: "Investment/Savings",
      InvestmentsOrSavins: "Investments & savings",
      DirectDebit: "Direct debit",
      BankTransfer: "Bank transfer",
      CreditCardChecking: "Credit card",
      FundsNotCover: "Other",
      IncomesExpenses: "Income/Expenses",
      NationalInsurance: "National insurance",
      NotReserveDuty: "Other",
      VAT: "VAT",
      Return: "Return",
      OnlyReturn: "Return only",
      Refund: "Refund",
      Cancelled: "Cancelled",
      ChqReturn: "Check return",
      HokReturn: "Standing order return",
      NegativeBehavior: "Negative behavior",
      Restricted: "Restricted account",
      Assets: "Assets",
      LoanTransaction: "Loan transaction",
      Loan: "Loan",
      LoanOverdue: "Overdue loan",
      OverdueSettlement: "Overdue settlement",
      MinistryOfConstrection: "Ministry of Construction",
      GovExpenses: "Government expenses",
      Deposit: "Deposit",
      Transfer: "Transfer",
      Insurance: "Insurance",
      Trading: "Trading",
      Pension: "Pension",
      RecentPension: "Pension update",
      Commission: "Commission",
      ChqCommission: "Check commission",
      HokCommission: "Standing order commission",
      HokAkamCommission: "Standing order commission",
      OverdueRelatedCommission: "Overdue commission",
      CashIncome: "Cash income",
      ForeignExchange: "Foreign exchange",
      Securities: "Securities",
      ChqIncome: "Check income",
      HealthFund: "Health fund",
      Bills: "Bills",
      InterestRate: "Interest",
      ReserveDuty: "Reserve duty",
      RegisteredMail: "Registered mail",
      AlertNotice: "Alert notice",
      Techni: "Technical operation",
      NotClassified: "Not classified",
      NonRevenue: "Other",
      Alimony: "Alimony",
    },
    Summary: "Periodic summary",
    Cashflow: "Cash flow",
    Income: "Income",
    Expenses: "Expenses",
    SavingsAsPartOfIncome: "Savings as % of income",
    Investments: "Investment/Savings",
    ExpensesByCategory: "Expenses breakdown",
    IncomeByCategory: "Income breakdown",
    categoryChartEmptyState: "No transactions to show for this period",
    IncomeList: "Income",
    ExpensesList: "Expenses",
    ConnectAccounts: "Connect accounts and cards",
    Bank: "Banks",
    Card: "Credit",
    Cash: "Cash",
    Manual: "Manual",
    ManualCredit: "Manual credit",
    ManualBank: "Manual banks",
    BankAndCard: "Banks and credit",
    Sum: "Amount",
    AdditionalData: "Additional info",
    transactionRuleHeader: "Customize your cash flow",
    ifAppearsInTransaction: "If in the transaction field",
    ifAppearsInTransactionShort: "If in transaction name",
    theValue: "the value appears:",
    valueEquals: "equals:",
    so: "then",
    date: "Date",
    sum: "Amount",
    sort: "Sort by",
    category: "Category",
    filter: "Filter",
    searchTransactions: "Search",
    searchTransactionsPlaceholder: "Name, description, or merchant",
    clearFilters: "Clear filters",
    noFilterResults: "No transactions match the filters",
    hideFromCashflow: "Hide from cash flow",
    moveToOtherCategory: "Assign to category",
    markAsInvestment: "Mark as investment/savings",
    extraInfo: "Additional info",
    transactionName: "Transaction name",
    equals: "Equals",
    contains: "Contains",
    removeRule: "Remove rule",
    cancel: "Cancel",
    andTheValueIs: "and the amount is",
    anySum: "Any amount",
    typeForAddingNewCategory: "Type to add a new category",
    addNewCategory: "Add new category",
    addConnection: "+ Add",
    id: "Transaction ID",
    configureCycle: "Manage monthly cycle",
    configureCycleDesc: "On which day of the month should the cycle start?",
    customDates: "Custom dates",
    SummaryByMonth: "Cash flow by month",
    noDataCurrentlyBEcauseYouAreNotConnected:
      "No data available because you are not connected to any accounts or cards",
    fetchErrorMessage:
      "We couldn't load your cash flow data. Please check your internet connection and try again.",
    loadingCashflow: "Loading your cash flow…",
    retryButton: "Try again",
    ToCashflow: "To cash flow",
    IfYouAreConnectedAndNoDataDisplayedGoToCashfow:
      "If you've already connected accounts and nothing is displayed, try going to ",
    ToShowMoreAccurateData: "For more accurate data, go to ",
    Help: "Help",
    manageTags: "Manage tags",
    manageCategories: "Manage categories",
    manageLaws: "Manage rules",
    senttings: "Settings",
    exportToFile: "Export to file",
    refresh: "Refresh",
    clickOnVideoToGetExplanation:
      "Click the video for an explanation on working with cash flow",
    manageCashflow: "Manage",
    tabCashflow: "Cashflow",
    tabBudget: "Budget",
    moveToBudget: "Move to budget",
    monthlyChartPremiumLock:
      "Monthly cash flow is available for Premium subscribers only",
    bankConnectedCardWarning:
      "Credit card transaction data from bank connections may be inaccurate, contain duplicates, or have gaps. It is recommended to connect your credit card directly through the credit card company",
    andAmountEquals: " and amount=",
    duplicateTransactionShort: "Duplicate",
    duplicateNotIncludedInCashflow: "Not included in cash flow",
    duplicateMarkedRealLine:
      "Marked as a real transaction · included in cash flow",
    duplicateConfirmCheckHint:
      "Press the check to include this transaction in your cash flow",
    duplicatePressCheckToUndoReal:
      "Press the check again to undo — it will be treated as a duplicate excluded from totals",
    duplicateIncludeInFlowButton: "Include in cash flow",
    duplicateUndoIncludeButton: "Stop including in cash flow",
    hiddenTransactionLabel: "Hidden transaction",
    ignoredByRuleShort: "Hidden",
    ignoredByRuleNotIncludedInCashflow: "Not included in cash flow",
    ignoredByRuleHint:
      "This transaction was hidden by a rule you set. Click the 👁 icon to undo",
    connectedCardShort: "Connected card",
    connectedCardNotIncludedInCashflow: "Not included in cash flow",
    connectedCardHint:
      "Credit card charge on your bank statement. The individual transactions are already counted from the card provider",
    transactionActions: "Actions",
    actionIgnore: "Hide from cash flow",
    actionUnignore: "Show in cash flow",
    actionCreateRule: "Create rule",
    actionEditRule: "Edit rule",
    actionChangeCategory: "Change category",
    actionEditTransaction: "Edit transaction",
    actionMarkInvestment: "Mark as investment/savings",
    actionUnmarkInvestment: "Unmark as investment/savings",
    moreInfoAndComments: "More info & comments",
    commentsLabel: "Comments",
    commentsPlaceholder: "Add a comment...",
    commentEditPlaceholder: "Edit comment...",
    commentSave: "Save",
    executionDate: "Execution date",
    transactionDateLabel: "Transaction date",
    billingValueDateLabel: "Billing date",
    merchantNameLabel: "Merchant",
    merchantDetailsLabel: "Details",
    merchantLocationLabel: "Location",
    beneficiaryName: "Beneficiary",
    businessAddress: "Business address",
    accountInfo: "Account info",
  },
  RUS: {
    CashflowSettings: {
      header: "Настройки денежного потока",
      dateSelectionText: "К какому месяцу относить кредитные транзакции?",
      transactionDate: "Месяц совершения транзакции",
      billingDate: "Месяц списания в банке",
      billingDateHelp: "Каждый расход отображается по месяцу списания в банке.",
      transactionDateHelp:
        "Каждый расход отображается по фактической дате покупки, даже если списание по кредитной карте произошло в следующем месяце.",
    },
    TransactionRulesForm: {
      ThisTransaction: "Правило для этой транзакции",
      RuleCreation: "Создать постоянное правило",
      AdvancedRule: "Расширенное правило",
      infoBanner:
        "Прошлые и будущие транзакции будут автоматически классифицированы по этому правилу",
      ifInField: "Если в поле",
      addAmountCondition: "Добавить условие по сумме",
      thenChooseAction: "Тогда - выберите действие:",
      chooseSubcategory: "Выберите подкатегорию:",
      chooseCategory: "Выберите категорию:",
      addComment: "Добавить комментарий",
      hideTransaction: "Скрыть транзакцию",
      markAsSavings: "Отметить как сбережение",
      categoryLockWarning:
        "Изменение родительской категории приведет к переназначению всех транзакций в этой подкатегории",
      unlockCategory: "Изменить родительскую категорию",
      unlockConfirmTitle: "Изменить родительскую категорию",
      unlockConfirmMessage: (sub: string) =>
        `Изменение родительской категории затронет все транзакции в подкатегории "${sub}". Продолжить?`,
      unlockConfirm: "Продолжить",
      unlockCancel: "Отмена",
    },
    ManageRules: {
      Sum: "Сумма",
      TransactionName: "Правило",
      MoreInfo: "Подробнее",
      Action: "Действие",
      Category: "Категория",
      Header: "Управление правилами",
      CategoryRules: "Правила категорий",
      IgnoreRules: "Правила игнорирования",
      TagRules: "Правила тегов",
      InvestmentRules: "Правила инвестиций",
      MatchingTransactions: "Совпадающие транзакции",
      search: "Поиск правил",
      sort: "Сортировка",
    },
    InsightStrings: {
      cardFees: "Комиссия за карту",
      reserverDutyString: "Военные сборы",
    },
    MultiSelect: {
      selectSomeItems: "Выберите счета и карты",
      allItemsAreSelected: "Все счета и карты выбраны",
      selectAll: "Выбрать все",
      search: "Поиск",
      noOptions: "Нет карт или счетов",
    },
    Months: {
      January: "Январь",
      February: "Февраль",
      March: "Март",
      April: "Апрель",
      May: "Май",
      June: "Июнь",
      July: "Июль",
      August: "Август",
      September: "Сентябрь",
      October: "Октябрь",
      November: "Ноябрь",
      December: "Декабрь",
      All: "Весь период",
    },
    CategoryTypes: {
      Main: "Группировка",
      Sub: "Детально",
    },
    Categories: {
      All: "Все",
      Uncategorized: "Другое",
      BusinessExpenses: "Бизнес-расходы",
      ChecksGeneral: "Чеки общие",
      CreditCardExpenses: "Кредитная карта",
      InterestRates: "Проценты",
      CashWithdrawls: "Снятие наличных",
      FinanceOther: "Финансы",
      Healthcare: "Здравоохранение",
      InsuranceAndFees: "Страхование и сборы",
      Saving: "Сбережения",
      HomeImprovementsOther: "Улучшения дома",
      Home: "Дом",
      Rent: "Аренда",
      Garden: "Сад",
      Other: "Прочее",
      ReimbursementsOther: "Возмещения",
      Services: "Услуги",
      Fees: "Комиссии за управление",
      Loans: "Кредиты",
      BenefitsOthers: "Льготы",
      CapitalMarket: "Фондовый рынок",
      BooksAndGames: "Книги и игры",
      Groceries: "Продукты",
      ShoppingOther: "Покупки",
      SportsAndFitness: "Спорт и фитнес",
      Restaurant: "Ресторан",
      ClothesAndAccessories: "Одежда и аксессуары",
      CoffeeAndSnacks: "Кофе и перекусы",
      Electronics: "Электроника",
      Pharmacy: "Аптека",
      CarAndFuel: "Автомобиль и топливо",
      Communications: "Связь",
      TransportOther: "Транспорт",
      Education: "Образование",
      HobbyAndSportsEquipment: "Хобби и спортинвентарь",
      GovernmentServices: "Государственные услуги",
      AlcoholAndTobacco: "Алкоголь и табак",
      CultureAndEvents: "Культура и мероприятия",
      Vacation: "Отпуск",
      Charity: "Благотворительность",
      PublicTransport: "Общественный транспорт",
      Bars: "Бары",
      Gifts: "Подарки",
      RenovationAndRepairs: "Ремонт",
      Flights: "Авиабилеты",
      Beauty: "Косметика",
      Taxi: "Такси",
      LeisureOther: "Досуг",
      FoodAndDrinksOther: "Еда и напитки",
      Finance: "Финансы",
      FoodAndDrinks: "Еда и напитки",
      Leisure: "Досуг",
      Shopping: "Покупки",
      Transport: "Транспорт",
      HouseholdAndServices: "Дом и услуги",
      HealthAndBeauty: "Здоровье и красота",
      HealthAndBeautyOther: "Здоровье и красота",
      HomeImprovements: "Улучшения дома",
      Reimbursements: "Возмещения",
      Benefits: "Льготы",
      Salary: "Зарплата",
      Utilities: "Коммунальные услуги",
      Mortgage: "Ипотека",
      FornitureAndInterior: "Мебель и интерьер",
      Hobbies: "Хобби",
      Pets: "Домашние животные",
      Kids: "Дети",
      BusinessVendor: "Бизнес-поставщик",
      Unknown: "Другое",
      EyeCare: "Офтальмология",
      SalaryOther: "Зарплата",
      Investments: "Инвестиции/Сбережения",
      InvestmentsOrSavins: "Инвестиции и сбережения",
      DirectDebit: "Прямое списание",
      BankTransfer: "Банковский перевод",
      CreditCardChecking: "Кредитная карта",
      FundsNotCover: "Другое",
      IncomesExpenses: "Доходы/Расходы",
      NationalInsurance: "Социальное страхование",
      NotReserveDuty: "Другое",
      VAT: "НДС",
      Return: "Возврат",
      OnlyReturn: "Только возврат",
      Refund: "Возмещение",
      Cancelled: "Отменено",
      ChqReturn: "Возврат чека",
      HokReturn: "Возврат постоянного поручения",
      NegativeBehavior: "Негативное поведение",
      Restricted: "Ограниченный счёт",
      Assets: "Активы",
      LoanTransaction: "Операция по кредиту",
      Loan: "Кредит",
      LoanOverdue: "Просроченный кредит",
      OverdueSettlement: "Погашение просрочки",
      MinistryOfConstrection: "Министерство строительства",
      GovExpenses: "Государственные расходы",
      Deposit: "Депозит",
      Transfer: "Перевод",
      Insurance: "Страхование",
      Trading: "Торговля",
      Pension: "Пенсия",
      RecentPension: "Обновление пенсии",
      Commission: "Комиссия",
      ChqCommission: "Комиссия за чек",
      HokCommission: "Комиссия за постоянное поручение",
      HokAkamCommission: "Комиссия за постоянное поручение",
      OverdueRelatedCommission: "Комиссия за просрочку",
      CashIncome: "Доход наличными",
      ForeignExchange: "Обмен валюты",
      Securities: "Ценные бумаги",
      ChqIncome: "Доход по чеку",
      HealthFund: "Больничная касса",
      Bills: "Счета",
      InterestRate: "Проценты",
      ReserveDuty: "Военные сборы",
      RegisteredMail: "Заказное письмо",
      AlertNotice: "Уведомление",
      Techni: "Техническая операция",
      NotClassified: "Не классифицировано",
      NonRevenue: "Другое",
      Alimony: "Алименты",
    },
    Summary: "Периодический итог",
    Cashflow: "Денежный поток",
    Income: "Доходы",
    Expenses: "Расходы",
    SavingsAsPartOfIncome: "Сбережения как % от дохода",
    Investments: "Инвестиции/Сбережения",
    ExpensesByCategory: "Расходы по категориям",
    IncomeByCategory: "Доходы по категориям",
    categoryChartEmptyState: "Нет транзакций за этот период",
    IncomeList: "Доходы",
    ExpensesList: "Расходы",
    ConnectAccounts: "Подключить счета и карты",
    Bank: "Банки",
    Card: "Кредитные карты",
    Cash: "Наличные",
    Manual: "Вручную",
    ManualCredit: "Кредитные карты вручную",
    ManualBank: "Банки вручную",
    BankAndCard: "Банки и кредитные карты",
    Sum: "Сумма",
    AdditionalData: "Дополнительная информация",
    transactionRuleHeader: "Настройте денежный поток",
    ifAppearsInTransaction: "Если в поле транзакции",
    ifAppearsInTransactionShort: "Если в названии транзакции",
    theValue: "содержится значение:",
    valueEquals: "равно:",
    so: "тогда",
    date: "Дата",
    sum: "Сумма",
    sort: "Сортировать по",
    category: "Категория",
    filter: "Фильтр",
    searchTransactions: "Поиск",
    searchTransactionsPlaceholder: "Название, описание или продавец",
    clearFilters: "Сбросить фильтры",
    noFilterResults: "Нет транзакций по выбранным фильтрам",
    hideFromCashflow: "Скрыть из денежного потока",
    moveToOtherCategory: "Назначить категорию",
    markAsInvestment: "Отметить как инвестицию/сбережение",
    extraInfo: "Дополнительная информация",
    transactionName: "Название транзакции",
    equals: "Равно",
    contains: "Содержит",
    removeRule: "Удалить правило",
    cancel: "Отмена",
    andTheValueIs: "и сумма равна",
    anySum: "Любая сумма",
    typeForAddingNewCategory: "Введите для добавления новой категории",
    addNewCategory: "Добавить новую категорию",
    addConnection: "+ Добавить",
    id: "ID транзакции",
    configureCycle: "Управление месячным циклом",
    configureCycleDesc: "С какого дня месяца начинать цикл?",
    customDates: "Пользовательские даты",
    SummaryByMonth: "Денежный поток по месяцам",
    noDataCurrentlyBEcauseYouAreNotConnected:
      "Нет данных, так как вы не подключены к счетам или картам",
    fetchErrorMessage:
      "Не удалось загрузить данные денежного потока. Проверьте подключение к интернету и попробуйте снова.",
    loadingCashflow: "Загружаем денежный поток…",
    retryButton: "Попробовать снова",
    ToCashflow: "К денежному потоку",
    IfYouAreConnectedAndNoDataDisplayedGoToCashfow:
      "Если вы уже подключили счета и ничего не отображается, попробуйте перейти ",
    ToShowMoreAccurateData: "Для более точных данных перейдите ",
    Help: "Помощь",
    manageTags: "Управление тегами",
    manageCategories: "Управление категориями",
    manageLaws: "Управление правилами",
    senttings: "Настройки",
    exportToFile: "Экспорт в файл",
    refresh: "Обновить",
    clickOnVideoToGetExplanation:
      "Нажмите на видео для объяснения работы с денежным потоком",
    manageCashflow: "Управление",
    tabCashflow: "Денежный поток",
    tabBudget: "Бюджет",
    moveToBudget: "Перейти к бюджету",
    monthlyChartPremiumLock:
      "Денежный поток по месяцам доступен только для подписчиков Премиум",
    bankConnectedCardWarning:
      "Данные о транзакциях по кредитным картам из банковских подключений могут быть неточными, содержать дубликаты или пропуски. Рекомендуется подключить кредитную карту напрямую через компанию-эмитент",
    andAmountEquals: " и сумма=",
    duplicateTransactionShort: "Дубликат",
    duplicateNotIncludedInCashflow: "Не учитывается в потоке",
    duplicateMarkedRealLine:
      "Отмечено как реальная транзакция · учитывается в потоке",
    duplicateConfirmCheckHint:
      "Нажмите галочку, чтобы учитывать транзакцию в потоке",
    duplicatePressCheckToUndoReal:
      "Нажмите снова, чтобы отменить — снова как дубликат вне сумм",
    duplicateIncludeInFlowButton: "Учитывать в потоке",
    duplicateUndoIncludeButton: "Не учитывать в потоке",
    hiddenTransactionLabel: "Скрытая транзакция",
    ignoredByRuleShort: "Скрыто",
    ignoredByRuleNotIncludedInCashflow: "Не учитывается в потоке",
    ignoredByRuleHint:
      "Эта транзакция скрыта правилом, которое вы задали. Нажмите на значок 👁, чтобы отменить",
    connectedCardShort: "Связанная карта",
    connectedCardNotIncludedInCashflow: "Не учитывается в потоке",
    connectedCardHint:
      "Списание по кредитной карте на банковском счёте. Отдельные транзакции уже учитываются от карточной компании",
    transactionActions: "Действия",
    actionIgnore: "Скрыть из потока",
    actionUnignore: "Показать в потоке",
    actionCreateRule: "Создать правило",
    actionEditRule: "Редактировать правило",
    actionChangeCategory: "Изменить категорию",
    actionEditTransaction: "Редактировать транзакцию",
    actionMarkInvestment: "Отметить как инвестицию/сбережение",
    actionUnmarkInvestment: "Снять отметку инвестиции/сбережения",
    moreInfoAndComments: "Дополнительная информация и комментарии",
    commentsLabel: "Комментарии",
    commentsPlaceholder: "Добавить комментарий...",
    commentEditPlaceholder: "Редактировать комментарий...",
    commentSave: "Сохранить",
    executionDate: "Дата выполнения",
    transactionDateLabel: "Дата транзакции",
    billingValueDateLabel: "Дата списания",
    merchantNameLabel: "Торговая точка",
    merchantDetailsLabel: "Детали",
    merchantLocationLabel: "Местоположение",
    beneficiaryName: "Получатель",
    businessAddress: "Адрес предприятия",
    accountInfo: "Информация о счёте",
  },
};
